<script setup lang="ts">
import type { AuthGatedAction } from '~/components/Auth/AuthGatedActionInfo.vue';

interface Props {
    action?: AuthGatedAction;
}

// PROPS
defineProps<Props>();

// COMPOSABLES
const { currentStep, goNext } = useOnboarding();

// EMITS
const emit = defineEmits(['success']);

// METHODS
const onOnboardingSuccess = (): void => {
    emit('success');
};
</script>

<template>
    <div class="flex flex-col gap-4">
        <template v-if="currentStep">
            <SignupOnboardingCompanyForm v-if="currentStep === 'Company'" @success="goNext" />
            <SignupOnboardingInfoForm v-if="currentStep === 'Info'" @next="goNext" />
            <SignupOnboardingContactForm v-if="currentStep === 'Contact'" @next="goNext" />
            <SignupOnboardingComplete v-if="currentStep === 'Complete'" :action="action" @success="onOnboardingSuccess" />
        </template>
    </div>
</template>
